export default "__VITE_ASSET__Dr2O2tRe__"